// ==============================|| OVERRIDES - INPUT ||============================== //

export default function Input(theme) {
	return {
		MuiInput: {
			defaultProps: {
				//disableUnderline: true
			},
			styleOverrides: {}
		}
	}
}
